import PageHeader from 'src/components/organisms/PageHeader';
import Footer from 'src/components/molecules/footer/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/components/organisms/ContentCard';
import { CustomDataGrid } from 'src/components/organisms/CustomDataGrid';
import { generateTablePageButtons } from 'src/utils/generateTablePageButtons';
import { useCampaignsTable } from 'src/hooks/table/configs/useCampaignsTable';
import CustomButton from 'src/components/atoms/buttons/CustomButton';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';

export  const Campaigns = () => {
    const [columns, tableSettings] = useCampaignsTable();
    return (
        <>
            <PageHeader  {...{
                title: "Campaigns",
                subTitle: "View and manage all campaigns", 
                components: [
                    ...generateTablePageButtons(tableSettings),
                    { component: <CustomButton title="New Campaign" icon={<AddTwoToneIcon />} actionUrl="/orders/campaigns/create" /> },
                ]
            }} />
            <ContentCardsContainer >
                <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} /> 
                </ContentCard>
            </ContentCardsContainer>


            <Footer />
        </>
    );
}
export default  Campaigns;

